<template>
	<div class="clearfix">
		<div class="pseudo-input">
			<input
				type="search"
				class="input-bare w-full flex-1"
				:placeholder="$t('session-type')"
				v-if="!selecteditems.length"
				@click="openAddModal"
			/>
			<span
				class="badge badge-secondary badge-sm mr-2 mb-2"
				v-for="(item, index) in selectedWorkbookDetail"
				v-bind:key="index"
			>
				{{ item.name }}
				<a @click="removeItem(item)"><b-icon icon="x"></b-icon></a>
			</span>
			<span
				class="badge badge-primary badge-sm mr-2 mb-2"
				v-if="selecteditems.length"
				@click="openAddModal"
			>
				<b-icon icon="plus"></b-icon> {{ $t('add') }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		selecteditems: Array
	},
	data: function() {
		return {
		}
	} ,
	mounted() {
	},
	methods: {
		openAddModal: function() {
			const self = this
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select'),
				selectCallback: function(selection) {
					if(self.selecteditems.indexOf(Number(selection.id)) != -1){
						self.selecteditems.splice(self.selecteditems.indexOf(Number(selection.id)), 1);
						this.selected.splice(this.selected.indexOf(selection), 1);
					} else {
						self.selecteditems.push(Number(selection.id));
						this.selected.push(selection);
					}
				},
				selected: this.selectedWorkbookDetail,
				data: this.$config.getValue('participationTypes'),
				captionKey: 'name'
			});
		},
		removeItem: function(selection) {
			if(this.selecteditems.indexOf(Number(selection.id)) != -1){
				this.selecteditems.splice(this.selecteditems.indexOf(Number(selection.id)), 1);
			}
		}
	},
	computed: {
		selectedWorkbookDetail: function() {
			var selected = [];
			this.$config.getValue('participationTypes').forEach(item =>{
  				if(this.selecteditems.indexOf(Number(item.id)) != -1){
  					selected.push(item);
  				}
  			})
  			return selected;
  		}
	},
};
</script>
